import { isResidentialTypeWoning } from '@comforttool/comfortcore';
/** Hoog tarief btw NL (particuliere verkoop / standaard B2B verlegd weergave). */
export const BTW_FRACTIE = 0.21;
export const FLOOR_BAND_MAX_S_M2 = 120;
export const FLOOR_BAND_MAX_M_M2 = 400;
export const FLOOR_BAND_MAX_L_M2 = 800;
export const FLOOR_BAND_MAX_XL_M2 = 1200;
export const PRICING_PARTICULIER_INCL_BTW = {
    S: 49.99,
    M: 69.99,
    L: 89.99,
    XL: 119.99,
};
export const PRICING_ZAKELIJK_EX_BTW = {
    S: 99,
    M: 149,
    L: 199,
    XL: 249,
};
/** Comfort Basis — particulier incl. btw. */
export const PRICING_PARTICULIER_BASIS_INCL_BTW = {
    S: 34.99,
    M: 49.99,
    L: 64.99,
    XL: 84.99,
};
/** Comfort Basis — zakelijk ex. btw. */
export const PRICING_ZAKELIJK_BASIS_EX_BTW = {
    S: 69,
    M: 104,
    L: 139,
    XL: 174,
};
const ZAKELIJKE_SEGMENTEN = new Set([
    'installateur',
    'aannemer',
    'vastgoedontwikkelaar',
    'projectontwikkelaar',
    'gemeente',
    'woningcorporatie',
    'vve',
]);
export function isZakelijkePrijzenSegment(segment) {
    return ZAKELIJKE_SEGMENTEN.has(segment);
}
export function floorPriceBand(vloeroppervlakte_m2, utiliteitGebouw) {
    if (vloeroppervlakte_m2 > FLOOR_BAND_MAX_XL_M2)
        return 'QUOTE';
    if (utiliteitGebouw) {
        if (vloeroppervlakte_m2 > FLOOR_BAND_MAX_L_M2)
            return 'XL';
        return 'L';
    }
    if (vloeroppervlakte_m2 > FLOOR_BAND_MAX_L_M2)
        return 'XL';
    if (vloeroppervlakte_m2 > FLOOR_BAND_MAX_M_M2)
        return 'L';
    if (vloeroppervlakte_m2 > FLOOR_BAND_MAX_S_M2)
        return 'M';
    return 'S';
}
export function bandOmschrijving(band, utiliteitGebouw) {
    if (band === 'QUOTE') {
        return utiliteitGebouw
            ? `niet-woning / utiliteit boven ${FLOOR_BAND_MAX_XL_M2} m² — offerte`
            : `woning boven ${FLOOR_BAND_MAX_XL_M2} m² — offerte`;
    }
    if (utiliteitGebouw) {
        if (band === 'XL')
            return `niet-woning / utiliteit ${FLOOR_BAND_MAX_L_M2 + 1}–${FLOOR_BAND_MAX_XL_M2} m² (band XL)`;
        return `niet-woning / utiliteit tot ${FLOOR_BAND_MAX_L_M2} m² (band L)`;
    }
    if (band === 'S')
        return `tot ${FLOOR_BAND_MAX_S_M2} m²`;
    if (band === 'M')
        return `${FLOOR_BAND_MAX_S_M2 + 1}–${FLOOR_BAND_MAX_M_M2} m²`;
    if (band === 'L')
        return `${FLOOR_BAND_MAX_M_M2 + 1}–${FLOOR_BAND_MAX_L_M2} m²`;
    return `${FLOOR_BAND_MAX_L_M2 + 1}–${FLOOR_BAND_MAX_XL_M2} m²`;
}
export function prijsSnapshotVoorInvoer(input) {
    const tier = input.bundleTier === 'basis' ? 'basis' : 'plus';
    const util = !isResidentialTypeWoning(input.type_woning);
    const band = floorPriceBand(input.vloeroppervlakte, util);
    const oms = bandOmschrijving(band, util);
    const zakelijk = isZakelijkePrijzenSegment(input.user_segment);
    if (band === 'QUOTE') {
        return {
            requiresQuote: true,
            band: 'QUOTE',
            bandOmschrijving: oms,
            isZakelijk: zakelijk,
            hoofdbedrag: 0,
            hoofdLabel: zakelijk ? 'ex. btw' : 'incl. btw',
            btwBedrag: 0,
            totaalInclBtw: 0,
        };
    }
    if (zakelijk) {
        const ex = tier === 'basis' ? PRICING_ZAKELIJK_BASIS_EX_BTW[band] : PRICING_ZAKELIJK_EX_BTW[band];
        const btw = Math.round(ex * BTW_FRACTIE * 100) / 100;
        const tot = Math.round((ex + btw) * 100) / 100;
        return {
            requiresQuote: false,
            bundleTier: tier,
            band,
            bandOmschrijving: oms,
            isZakelijk: true,
            hoofdbedrag: ex,
            hoofdLabel: 'ex. btw',
            btwBedrag: btw,
            totaalInclBtw: tot,
        };
    }
    const incl = tier === 'basis' ? PRICING_PARTICULIER_BASIS_INCL_BTW[band] : PRICING_PARTICULIER_INCL_BTW[band];
    const ex = Math.round((incl / (1 + BTW_FRACTIE)) * 100) / 100;
    const btw = Math.round((incl - ex) * 100) / 100;
    return {
        requiresQuote: false,
        bundleTier: tier,
        band,
        bandOmschrijving: oms,
        isZakelijk: false,
        hoofdbedrag: incl,
        hoofdLabel: 'incl. btw',
        btwBedrag: btw,
        totaalInclBtw: incl,
    };
}
